module.exports = __webpack_public_path__ + "static/media/hide-betslips.555a6fe5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hide-betslips.svg
// module id = 2413
// module chunks = 7